import { createSlice } from "@reduxjs/toolkit";
import { scryptx } from "../utils/localStorage";

const lsToken = scryptx.getObject("token");
const lsUser = scryptx.getObject("user");

const initialState = {
  id: lsToken?.id || null,
  type: lsToken?.type || null,
  accessToken: lsToken?.accessToken || null,
  refreshToken: lsToken?.refreshToken || null,
  expiresIn: lsToken?.expiresIn || null,
  tokenExpirationTime: lsToken?.tokenExpirationTime || null,
  user: lsUser || null,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTokens: (state, action) => {
      const { id, type, access_token, refresh_token, expires_in } = action.payload;
      const tokenExpirationTime = Date.now() + expires_in * 1000;
      state.id = id;
      state.type = type;
      state.accessToken = access_token;
      state.refreshToken = refresh_token;
      state.expiresIn = expires_in;
      state.tokenExpirationTime = tokenExpirationTime;
      scryptx.setObject("token", {
        id,
        type,
        accessToken: access_token,
        refreshToken: refresh_token,
        expiresIn: expires_in,
        tokenExpirationTime,
      });
    },
    setUser: (state, { payload: user }) => {
      state.user = user;
      scryptx.setObject("user", user);
    },
    clearTokens: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.expiresIn = null;
      state.tokenExpirationTime = null;
      state.user = null;
      scryptx.clear();
    },
  },
});

export const { setTokens, clearTokens, setUser } = slice.actions;
export const selectAccessToken = (state) => state?.auth?.accessToken || null;
export const selectCurrentUser = (state) => state?.auth?.user || null;
export const selectTokenInfo = (state) => state?.auth || null;
export default slice.reducer;
